import { useEffect, useState } from 'react'

export default function HandleClickable(
  gameState: number,
  isError: boolean,
  setIsClickable: (b: boolean) => void,
) {
  const [delay, setDelay] = useState<number>(0)
  useEffect(() => {
    if (isError) {
      setDelay(200)
    } else {
      switch (gameState) {
        case 0:
          setDelay(750)
          break
        case 4:
          setDelay(2100)
          break
        case 5:
        case 6:
        case 11:
          setDelay(1500)
          break
        default:
          setDelay(200)
          break
      }
    }

  }, [gameState, isError])

  useEffect(() => {
    // setIsClickable(true)
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      setIsClickable(false)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [delay, setIsClickable])
}
